import { omitKeys } from "@hex-insights/core";
import { AddressFormValues } from "../Address";
import { EmailAddressFormValues } from "../EmailAddress";
import { PhoneNumberFormValues } from "../PhoneNumber";
import * as PersonFormValues from "./form-values";

export type Create = Omit<PersonFormValues.Create, "addressIDs"> & {
	addresses: AddressFormValues.CreateInPerson[];
};

export type CreateRequiredKey = Extract<keyof Create, "givenName" | "familyName">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	...omitKeys(PersonFormValues.initialCreate, ["addressIDs"]),
	emailAddresses: [{ ...EmailAddressFormValues.blankItemInPerson, isPrimary: true }],
	phoneNumbers: [{ ...PhoneNumberFormValues.blankItemInPerson, isPrimary: true }],
	addresses: [AddressFormValues.blankItemInPerson],
};

export type CreateInEmployee = Omit<Create, "employeeID">;

export type CreateInEmployeeRequiredKey = Exclude<CreateRequiredKey, "employeeID">;

export type CreateInEmployeeSubset<K extends keyof CreateInEmployee = keyof CreateInEmployee> = Pick<
	CreateInEmployee,
	CreateInEmployeeRequiredKey | K
>;

export const blankItemInEmployee: CreateInEmployee = omitKeys(initialCreate, ["employeeID"]);

export type CreateInGuardian = Omit<Create, "guardianID"> & {
	addressSameAsFormIdentifier: string | null;
};

export type CreateInGuardianRequiredKey = Exclude<CreateRequiredKey, "guardianID">;

export type CreateInGuardianSubset<K extends keyof CreateInGuardian = keyof CreateInGuardian> = Pick<
	CreateInGuardian,
	CreateInGuardianRequiredKey | K
>;

export const blankItemInGuardian: CreateInGuardian = {
	...omitKeys(initialCreate, ["guardianID"]),
	addressSameAsFormIdentifier: null,
};

export type CreateInStudent = Omit<Create, "studentID">;

export type CreateInStudentRequiredKey = Exclude<CreateRequiredKey, "studentID">;

export type CreateInStudentSubset<K extends keyof CreateInStudent = keyof CreateInStudent> = Pick<
	CreateInStudent,
	CreateInStudentRequiredKey | K
>;

export const blankItemInStudent: CreateInStudent = omitKeys(initialCreate, ["studentID"]);
